// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"767":"f19486e120ab56e4","860":"e3e4fadc4e2b7d68"}[chunkId] + ".js";
};